/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const profileEventSchema = z.enum(['updated', 'primary-changed', 'archived'])

export type ProfileEventSchema = z.infer<typeof profileEventSchema>
